module.exports = __webpack_public_path__ + "static/media/YM57_3.97755d00.jpg";